"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
var SocialIcon_1 = tslib_1.__importDefault(require("../SocialIcon"));
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject([""], [""])));
var StyledIcon = (0, styled_components_1["default"])(SocialIcon_1["default"])(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  margin: ", "px;\n"], ["\n  margin: ", "px;\n"])), function (_a) {
    var margin = _a.margin;
    return margin;
});
var SocialIcons = function (_a) {
    var _b = _a.icons, icons = _b === void 0 ? [] : _b, className = _a.className, _c = _a.variant, variant = _c === void 0 ? 'color' : _c, _d = _a.size, size = _d === void 0 ? 32 : _d, renderIcon = _a.renderIcon, restProps = tslib_1.__rest(_a, ["icons", "className", "variant", "size", "renderIcon"]);
    if (icons.length === 0) {
        return null;
    }
    return (React.createElement(Wrapper, tslib_1.__assign({ className: className }, restProps), icons.map(function (i) { return (React.createElement(React.Fragment, { key: i }, renderIcon(i, React.createElement(StyledIcon, { name: i, variant: variant, size: size, margin: size / 6 })))); })));
};
exports["default"] = SocialIcons;
var templateObject_1, templateObject_2;
